/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect } from 'react-native-svg';

import { IconProps } from '../lib';

function Diamond(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Rect
        x={51.63247}
        y={51.63247}
        width={152.73506}
        height={152.73506}
        rx={8}
        transform="translate(-53.01934 128) rotate(-45)"
        opacity={0.2}
      />
      <Rect
        x={51.63247}
        y={51.63247}
        width={152.73506}
        height={152.73506}
        rx={8}
        transform="translate(-53.01934 128) rotate(-45)"
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  );
}

export default Diamond;
